<ng-container *appTranslate="let t">
  <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 col gap-4 items-center">
    <a [routerLink]="['/app']" class="row bg-primary-default rounded-lg p-4">
      <img class="logo-img" ngSrc="assets/layout/images/logo.png" width="53" height="53" />
      <img class="logo-txt" ngSrc="assets/layout/images/logo-text.svg" height="18" width="116" />
    </a>

    <div class="col items-center">
      <h2 class="text-page-heading text-center">{{ t("unsubscribe.question") }}</h2>
      <span class="text-body-text-regular">{{ t("unsubscribe.info") }}</span>
    </div>
    <new-ui-button
      [label]="t('unsubscribe.title')"
      severity="warn"
      (onClick)="onUnsubscribe()"
      [disabled]="showSuccess"
    />

    @if (showSuccess) {
      <p-message severity="info" variant="simple" size="small">{{ t("unsubscribe.success") }}</p-message>
    }
  </div>
</ng-container>
